import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Search } from 'lucide-react'

export function SearchBar() {
  const navigate = useNavigate()
  const [q, setQ] = useState('')

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault()
        const needle = q.trim()
        if (!needle) return
        navigate(`/tim-kiem?q=${encodeURIComponent(needle)}`)
      }}
      className="relative w-full max-w-[560px]"
    >
      <input
        value={q}
        onChange={(e) => setQ(e.target.value)}
        type="search"
        placeholder="Tìm kiếm xe máy điện, xe đạp điện..."
        className="w-full h-11 rounded-md border border-border bg-surface pl-4 pr-14 text-sm outline-none focus:border-brand-500 transition"
      />
      <button
        type="submit"
        className="absolute right-0 top-0 h-full w-12 bg-brand-600 hover:bg-brand-700 rounded-r-md flex items-center justify-center text-white transition"
        aria-label="Tìm kiếm"
      >
        <Search className="w-4 h-4" />
      </button>
    </form>
  )
}
